import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';

var MeetingBook = /*#__PURE__*/function (_Vue) {
  _inherits(MeetingBook, _Vue);

  var _super = _createSuper(MeetingBook);

  function MeetingBook() {
    var _this;

    _classCallCheck(this, MeetingBook);

    _this = _super.call(this);
    _this.bgColor = ['rgba(212,212,212,.9)', 'rgba(212,212,212,.6)', 'rgba(212,212,212,.3)'];
    _this.mouseEnterScheduleId = '';
    _this.meetingStartTimeObj = {
      time: '',
      index: -1
    };
    _this.meetingEndTimeObj = {
      time: '',
      index: -1
    };
    _this.isActiveList = [];
    return _this;
  }

  _createClass(MeetingBook, [{
    key: "chooseTime",
    value: function chooseTime(params) {
      return params;
    }
  }, {
    key: "chooseStart",
    value: function chooseStart() {}
  }, {
    key: "selectTribunalIdChange",
    value: function selectTribunalIdChange(val) {
      if (!val || val !== this.tribunalId) {
        this.resetTime();
      }
    }
  }, {
    key: "meetingEnter",
    // meeting进入
    value: function meetingEnter(scheduleId) {
      this.mouseEnterScheduleId = scheduleId;
    } // meeting离开

  }, {
    key: "meetingLeave",
    value: function meetingLeave() {
      this.mouseEnterScheduleId = '';
    } // 计算是否为自己的排期

  }, {
    key: "isMySchedule",
    value: function isMySchedule(chiefJudgeId, clerkId) {
      return this.$store.getters.userInfo.userId === chiefJudgeId || this.$store.getters.userInfo.userId === clerkId;
    } // 计算是否显示点标志

  }, {
    key: "isShowRaduis",
    value: function isShowRaduis(startTime, endTime) {
      var hour = Number(endTime.split(':')[0]) - Number(startTime.split(':')[0]);
      var min = Number(endTime.split(':')[1]) - Number(startTime.split(':')[1]);

      if (hour * 60 + min === 30) {
        return true;
      }

      return false;
    } // 计算时间差

  }, {
    key: "calTimeTap",
    value: function calTimeTap(startTime, endTime) {
      var hour = Number(endTime.split(':')[0]) - Number(startTime.split(':')[0]);
      var min = Number(endTime.split(':')[1]) - Number(startTime.split(':')[1]);
      return {
        hour: hour,
        min: min
      };
    } // 完整日期格式的开始时间，方便使用moment

  }, {
    key: "totalStartTime",
    value: function totalStartTime(time) {
      return "".concat(this.$moment().format('YYYY-MM-DD'), " ").concat(time);
    } // 计算样式

  }, {
    key: "calStyle",
    value: function calStyle(type, startTime, endTime) {
      var _this$calTimeTap = this.calTimeTap(startTime, endTime),
          hour = _this$calTimeTap.hour,
          min = _this$calTimeTap.min;

      var intNum = (hour + min / 60) / this.intervalData;
      var floorNum = (hour + min / 60) % this.intervalData;
      var widthBlockNum = Math.floor(intNum) + (floorNum ? 1 : 0);
      var leftBlockNum = Math.floor(intNum);

      if (type === 'left') {
        return "calc(".concat(leftBlockNum / this.blockSum * 100, "% + 1px)");
      }

      return "calc(".concat(widthBlockNum / this.blockSum * 100, "% - 1px)");
    } // 获取时间

  }, {
    key: "getBlockTime",
    value: function getBlockTime(index) {
      var dayString = this.$moment().format('YYYY-MM-DD');
      var timeString = "".concat(dayString, " ").concat(this.startTime);
      return this.$moment(timeString).add(this.intervalData * index, 'h').format('HH:mm');
    } // 点击块

  }, {
    key: "chooseBlock",
    value: function chooseBlock(index) {
      // 如果禁止编辑或如果只显示，不允许点击
      if (!this.canEdit || this.disabled) {
        return;
      } // 如果选择了开始和结束时间


      if (this.meetingStartTimeObj.index !== -1 && this.meetingEndTimeObj.index !== -1) {
        this.resetTime();
      }

      this.chooseStart();

      if (this.meetingStartTimeObj.index === -1) {
        this.isActiveList.splice(index, 1, true);
        this.meetingStartTimeObj.index = index;
        return;
      }

      if (!this.hasTaken(this.meetingStartTimeObj.index, index)) {
        // 初始化块
        this.resetTime();
        this.$message.error('已占用');
        return;
      }

      this.meetingEndTimeObj.index = index;

      if (index >= this.meetingStartTimeObj.index) {
        this.meetingStartTimeObj.time = this.$moment(this.totalStartTime(this.startTime)).add(this.intervalData * this.meetingStartTimeObj.index, 'h').format('HH:mm');
        this.meetingEndTimeObj.time = this.$moment(this.totalStartTime(this.startTime)).add(this.intervalData * (index + 1), 'h').format('HH:mm');
        this.setBlockActive(this.meetingStartTimeObj.index, index);
      } else {
        this.meetingStartTimeObj.time = this.$moment(this.totalStartTime(this.startTime)).add(this.intervalData * (this.meetingStartTimeObj.index + 1), 'h').format('HH:mm');
        this.meetingEndTimeObj.time = this.$moment(this.totalStartTime(this.startTime)).add(this.intervalData * index, 'h').format('HH:mm');
        this.setBlockActive(index, this.meetingStartTimeObj.index);
      } // 抛出事件


      var params;

      if (index >= this.meetingStartTimeObj.index) {
        // 判断开始块的index小于结束块的index
        params = {
          startTimeObj: this.meetingStartTimeObj,
          endTimeObj: this.meetingEndTimeObj
        };
      } else {
        params = {
          startTimeObj: this.meetingEndTimeObj,
          endTimeObj: this.meetingStartTimeObj
        };
      }

      this.chooseTime(params);
    }
  }, {
    key: "setBlockActive",
    value: function setBlockActive(startIndex, endIndex) {
      this.isActiveList = new Array(this.blockSum);
      this.isActiveList.fill(true, startIndex, endIndex + 1);

      if (startIndex >= 1) {
        this.isActiveList.fill(false, 0, startIndex - 1);
      }

      this.isActiveList.fill(false, endIndex + 1, this.isActiveList.length);
    } // 计算是否占用已有块

  }, {
    key: "hasTaken",
    value: function hasTaken(startIndex, endIndex) {
      if (endIndex >= startIndex) {
        // 判断开始块的index小于结束块的index
        for (var i = startIndex + 1; i < endIndex; i++) {
          if (this.takenSet.has(i)) {
            return false;
          }
        }

        return true;
      }

      for (var _i = endIndex + 1; _i < startIndex; _i++) {
        if (this.takenSet.has(_i)) {
          return false;
        }
      }

      return true;
    } // 初始化选择时间

  }, {
    key: "resetTime",
    value: function resetTime() {
      this.meetingStartTimeObj = {
        time: '',
        index: -1
      };
      this.meetingEndTimeObj = {
        time: '',
        index: -1
      }; // 为触发响应式，直接更新指针

      this.isActiveList = new Array(this.blockSum);
      this.isActiveList.fill(false);
    }
  }, {
    key: "created",
    value: function created() {
      this.isActiveList.length = this.blockSum;
      this.isActiveList.fill(false);
    }
  }, {
    key: "intervalData",
    get: function get() {
      if (/min/.test(this.interval)) {
        return parseInt(this.interval.split('min')[0]) / 60;
      }

      if (/h/.test(this.interval)) {
        return parseInt(this.interval.split('h')[0]);
      } // 默认为0.5小时


      return 0.5;
    }
  }, {
    key: "blockSum",
    get: function get() {
      var startHour = Number(this.startTime.split(':')[0]);
      var endHour = Number(this.endTime.split(':')[0]);
      return (endHour - startHour) / this.intervalData;
    } // 计算占有格子index的set

  }, {
    key: "takenSet",
    get: function get() {
      var _this2 = this;

      var takenSet = new Set();
      this.scheduleList.forEach(function (item) {
        var _this2$calTimeTap = _this2.calTimeTap(_this2.startTime, item.planStartTime),
            startHour = _this2$calTimeTap.hour,
            startMin = _this2$calTimeTap.min;

        var startNum = (startHour + startMin / 60) / _this2.intervalData;
        var startFloorNum = (startHour + startMin / 60) % _this2.intervalData;
        var intStartNum = Math.floor(startNum) + (startFloorNum ? 0 : 1);

        var _this2$calTimeTap2 = _this2.calTimeTap(item.planStartTime, item.planEndTime),
            diffHour = _this2$calTimeTap2.hour,
            diffMin = _this2$calTimeTap2.min;

        var blockNum = (diffHour + diffMin / 60) / _this2.intervalData;
        var blockFloorNum = (diffHour + diffMin / 60) % _this2.intervalData;
        var intFloorNum = Math.floor(blockNum) + (blockFloorNum ? 1 : 0);

        for (var i = 0; i < intFloorNum; i++) {
          takenSet.add(i + intStartNum);
        }
      });
      return takenSet;
    }
  }]);

  return MeetingBook;
}(Vue);

__decorate([Prop({
  required: true
})], MeetingBook.prototype, "selectTribunalId", void 0);

__decorate([Prop({
  required: true
})], MeetingBook.prototype, "startTime", void 0);

__decorate([Prop({
  required: true
})], MeetingBook.prototype, "endTime", void 0);

__decorate([Prop({
  default: '30min'
})], MeetingBook.prototype, "interval", void 0);

__decorate([Prop()], MeetingBook.prototype, "date", void 0);

__decorate([Prop()], MeetingBook.prototype, "canEdit", void 0);

__decorate([Prop()], MeetingBook.prototype, "disabled", void 0);

__decorate([Prop()], MeetingBook.prototype, "scheduleList", void 0);

__decorate([Prop()], MeetingBook.prototype, "tribunalId", void 0);

__decorate([Emit('chooseTime')], MeetingBook.prototype, "chooseTime", null);

__decorate([Emit('chooseStart')], MeetingBook.prototype, "chooseStart", null);

__decorate([Watch('selectTribunalId')], MeetingBook.prototype, "selectTribunalIdChange", null);

MeetingBook = __decorate([Component], MeetingBook);
export default MeetingBook;